import React, { useState, useEffect } from "react";
import { Check, Star, ChevronLeft, ChevronRight } from "lucide-react";

const PricingSection = ({ openPopup }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const plans = [
    {
      name: "Essentials",
      price: "$45",
      subtitle: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "State E-Filing",
        "Trademark Secured",
      ],
      note: "Govt. filing fee not included",
      highlighted: false,
    },
    {
      name: "Enhanced",
      price: "$149",
      subtitle: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
      ],
      note: "Govt. filing fee not included",
      highlighted: false,
    },
    {
      name: "Deluxe",
      price: "$299",
      subtitle: "+ Federal Filing Fee",
      badge: "Recommended",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
      ],
      note: "Govt. filing fee not included",
      highlighted: true,
    },
    {
      name: "Platinum",
      price: "$349",
      subtitle: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
        "High Approval Rate",
        "Comprehensive Search Report",
        "High Priority Service",
        "Cease & Desist Letter",
      ],
      note: "Govt. filing fee not included",
      highlighted: false,
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % plans.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + plans.length) % plans.length);
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Transparent Pricing Plans</h2>
          <p className="section-subtitle">
            Choose the Perfect Package for Your Trademark Registration Needs
          </p>
        </div>

        {isMobile ? (
          <div className="pricing-slider">
            <button className="slider-arrow prev" onClick={prevSlide}>
              <ChevronLeft size={24} />
            </button>
            
            <div className="pricing-card-wrapper">
              <div
                className={`pricing-card ${plans[currentSlide].highlighted ? "highlighted" : ""}`}
              >
                {plans[currentSlide].badge && (
                  <div className="pricing-badge">
                    <Star size={14} />
                    {plans[currentSlide].badge}
                  </div>
                )}
                <h3 className="pricing-plan-name">{plans[currentSlide].name}</h3>
                <div className="pricing-price">
                  <span className="price-amount">{plans[currentSlide].price}</span>
                  <span className="price-subtitle">{plans[currentSlide].subtitle}</span>
                </div>
                <div className="pricing-features-wrapper">
                  <ul className="pricing-features">
                    {plans[currentSlide].features.map((feature, idx) => (
                      <li key={idx} className="pricing-feature">
                        <Check className="feature-check-icon" size={18} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="pricing-note">{plans[currentSlide].note}</p>
                <a href="#contact" className="pricing-cta-button">
                  Get Started Now
                </a>
              </div>
            </div>

            <button className="slider-arrow next" onClick={nextSlide}>
              <ChevronRight size={24} />
            </button>

            <div className="slider-dots">
              {plans.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? "active" : ""}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="pricing-grid">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`pricing-card ${plan.highlighted ? "highlighted" : ""}`}
              >
                {plan.badge && (
                  <div className="pricing-badge">
                    <Star size={14} />
                    {plan.badge}
                  </div>
                )}
                <h3 className="pricing-plan-name">{plan.name}</h3>
                <div className="pricing-price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-subtitle">{plan.subtitle}</span>
                </div>
                <div className="pricing-features-wrapper">
                  <ul className="pricing-features">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="pricing-feature">
                        <Check className="feature-check-icon" size={18} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="pricing-note">{plan.note}</p>
                <a href="#contact" className="pricing-cta-button">
                  Get Started Now
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PricingSection;
